import { render } from "./PlayStrategyView.vue?vue&type=template&id=6bfb4b30&scoped=true"
import script from "./PlayStrategyView.vue?vue&type=script&lang=js"
export * from "./PlayStrategyView.vue?vue&type=script&lang=js"

import "./PlayStrategyView.vue?vue&type=style&index=0&id=6bfb4b30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfb4b30"],['__file',"resources/js/components/playbooks/PlayStrategyView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bfb4b30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bfb4b30', __exports__)) {
    api.reload('6bfb4b30', __exports__)
  }
  
  module.hot.accept("./PlayStrategyView.vue?vue&type=template&id=6bfb4b30&scoped=true", () => {
    api.rerender('6bfb4b30', render)
  })

}


export default __exports__